import React from 'react';

import { WebBookmarkCard } from '../../../components/WebBookmarkCard';
import { WebBookmarkComponentProps } from '../types';

const FileComponent: React.FC<WebBookmarkComponentProps> = (props) => {
  const { url, title, desc, img, layout, coverImg } = props;
  if (!url || !title) {
    return null;
  }

  return (
    <div className="lygo-web-bookmark mt-32 flex w-full justify-center">
      <WebBookmarkCard
        coverImg={coverImg}
        desc={desc}
        img={img}
        layout={layout}
        title={title}
        url={url}
      />
    </div>
  );
};

export default FileComponent;
